module.exports = __webpack_public_path__ + "static/media/topbj.f7039afc.png";